module.exports = __webpack_public_path__ + "img/banner.def1f4f6.png";